import { Box, Button, Container, Input, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import CustomButton from "../components/CustomButton";
import { zim } from "../assets/images";
import { collection, db, getDocs } from "../firebaseConfig";
import LoadingScreen from "../components/loading/LoadingScreen";
import { SickTwoTone } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const Sites = () => {
  const [active, setActive] = useState("all sites");
  const [sites, setSites] = useState([]);
  const [heading, setHeading] = useState("All Learning Sites");
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

  // Fetch data from Firestore when the component loads
  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      const querySnapshot = await getDocs(collection(db, "sites"));
      const siteList = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      setSites(siteList);
      console.log(siteList);
      setLoading(false);
    };

    fetchData();
  }, []);

  const filter = [
    {
      id: "all sites",
      label: "All learning sites",
    },
    {
      id: "Early Childhood",
      label: "Early Childhood",
    },
    {
      id: "Primary",
      label: "Primary",
    },
    {
      id: "Secondary",
      label: "Secondary",
    },
  ];

  const filteredSites = sites.filter((site) =>
    site.siteName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const finalFilteredSites = filteredSites.filter(
    (site) => active === "all sites" || site.category === active
  );

  return (
    <>
      {loading ? (
        <Box>
          <LoadingScreen />
        </Box>
      ) : (
        <>
          <Box
            sx={{
              width: "100vw",
              height: { md: "70vh" },
              backgroundColor: "secondary.main",
            }}
          >
            <Container
              sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                justifyContent: "space-between",
                alignItems: "center",
                height: "inherit",
                pt: { xs: 10, md: 0 },
                pb: { xs: 5, md: 0 },
              }}
            >
              <Box sx={{ width: { xs: "100%", md: "50%" } }}>
                <Typography variant="h2" sx={{ my: 3, color: "primary.dark" }}>
                  Eagle Learning Sites
                </Typography>
                <Typography variant="body1" sx={{ color: "primary.dark" }}>
                  Eagle learning has a growing number of sites across Zimbabwe
                  that meet various learning needs and age groups.
                </Typography>
                <Box sx={{ my: 3 }}>
                  {filter.map((filt) => (
                    <Button
                      key={filt.id}
                      sx={{
                        backgroundColor:
                          active === filt.id ? "primary.main" : "primary.dark",
                        borderRadius: "50px",
                        py: 1.5,
                        px: 2,
                        mr: 0.5,
                      }}
                      onClick={() => {
                        setActive(filt.id);
                        setHeading(filt.label);
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          textTransform: "none",
                          color:
                            active === filt.id
                              ? "primary.dark"
                              : "secondary.main",
                        }}
                      >
                        {filt.label}
                      </Typography>
                    </Button>
                  ))}
                </Box>
                <Input
                  variant="outlined"
                  placeholder="Search for Eagle learning sites..."
                  sx={{
                    color: "white",
                    width: { xs: "100%", md: "50%" },
                    my: { xs: 3.5 },
                  }}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  value={searchTerm}
                />
              </Box>
              <img alt="Eagle learning sites" src={zim} width={450} />
            </Container>
          </Box>
          <Box sx={{ width: "100vw" }}>
            <Typography
              variant="h2"
              color="#222222"
              sx={{ my: 2, textAlign: "center" }}
            >
              {heading}
            </Typography>
            {finalFilteredSites.length !== 0 ? (
              finalFilteredSites.map((site) => (
                <Container
                  key={site.id}
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    height: { xs: "70vh", md: "50vh" },
                  }}
                >
                  <Box
                    sx={{
                      position: "relative",
                      display: { xs: "none", md: "block" },
                      top: 50,
                      left: { xs: 0, md: 50 },
                      width: { xs: "70px", md: "60vw" },
                      height: { xs: "60px", md: "80%" },
                      backgroundColor: "primary.main",
                      zIndex: 1,
                      backgroundImage: `url(${site.img})`,
                      backgroundSize: "cover",
                      borderRadius: 5,
                    }}
                  />
                  <Box
                    sx={{
                      position: "relative",
                      top: 80,
                      left: 0,
                      width: { xs: "90vw", md: "40vw" },
                      minHeight: "65%",
                      maxHeight: "90%",
                      backgroundColor: "secondary.main",
                      zIndex: 2,
                      padding: 2,
                    }}
                  >
                    <Typography
                      variant="h7"
                      sx={{ textTransform: "uppercase" }}
                      color="white"
                    >
                      Eagle learning site
                    </Typography>
                    <Typography
                      variant="h2"
                      color="primary.dark"
                      sx={{ my: 1 }}
                    >
                      {site.siteName}
                    </Typography>
                    <Typography variant="body2" color="primary.dark">
                      {site.shortDescr}
                    </Typography>
                    <CustomButton
                      sx={{ mt: 2.5 }}
                      onClick={() => navigate(`/sites/${site.id}`)}
                    >
                      <Typography variant="body1">Learn more</Typography>
                    </CustomButton>
                  </Box>
                </Container>
              ))
            ) : (
              <Container
                sx={{
                  height: "50vh",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <SickTwoTone
                  sx={{ color: "priamry.main", height: 80, width: 80 }}
                />
                <Typography variant="h2">No Sites Found</Typography>
              </Container>
            )}
          </Box>
        </>
      )}
    </>
  );
};

export default Sites;
